/**
 * Created by rjulius on 2/9/16.
 */
import DisplayVM from "common/forms/FormsDisplayViewModel";
import topic from "common/managers/topic";
import urlapi from "common/managers/urlapi";
import formsUrlApi from "common/forms/formsUrlApi";
import locale from "common/managers/locale";
import join from "common/helper/join";
import window from "common/objects/window";
export default $.extend({}, DisplayVM, {

    _events: [],

    // mode for displaying the viewable or editable form
    showForm: true,

    // mode for displaying an error message instead of the form
    showError: false,

    // will be set to true if a Load URL submit action needs to run on submit.
    // messages displayed to the user are changed based on this.
    isRedirecting: false,

    //Is there feedback of some sort of display
    _haveFeedback: false,

    // URL to redirect to, from a Load Form Submit Action
    redirectUrl: false,

    // overridden from base VM - hides part of the header text
    hideContext: true,

    onInit: function() {
        this.initDisplay();
        this.bind("closeForm", $.proxy(this._onSubmitClose, this));
        topic.subscribe("form/success/message", $.proxy(this._displaySuccessFeedback, this));
        this.bind("forms/notify/error", $.proxy(this._onError, this));
        this.bind("forms/render/error", $.proxy(this._onRenderError, this));
        this.bind("open/window", $.proxy(this._openWindow, this));
    },

    updateHeader: function(header) {
        window.document.title = header;
    },

    _onError: function(msgObj) {
        this.displayErrorFeedback(msgObj.data.message);
    },

    _onRenderError: function(msg) {
        this.set("errorMessage", msg);
        this._onSubmitClose();
    },

    _resetState: function() {
        this.set("showForm", true);
        this.set("showError", false);
        this.set("errorMessage", "");
        this.set("successMessage", "");
        this.set("isRedirecting", false);
        this.set("redirectUrl", false);
    },

    /**
     * A URL API call is the ONLY way to legitimately access the External Forms module.
     */
    handleUrlApi: function() {
        var me = this;
        this._resetState();
        var params = urlapi.params();
        return formsUrlApi.classify(params).then(function(result) {

            if (result.display == formsUrlApi.MISSING_ID) {
                me.displayErrorFeedback(locale.get("external.urlapi.missing", join([
                    "formDesignId",
                    "formName",
                    "formId",
                    "docId"
                ], undefined, true)));
                return $.Deferred().reject().promise();
            }

            // Open the form, in either view or edit mode, depending on the parameters passed.
            if (result.mode == "view") {
                return me.viewForm(result.form);
            } else {
                return me.editForm(result.form);
            }
        });
    },

    /**
     * Prepare form and step data differently, depending on viewing context.
     * @param currentStep
     */
    prepareStepData: function(currentStep) {
        if (context.endpoint == "m") {
            this._prepMobileData(currentStep);
        } else {
            this._setFormStyles();
        }
    },

    /**
     * In external forms module, opening a window (which comes from a Load External URL Submit Action)
     * doesn't actually open a new window, but rather redirects the current browser window.
     * @private
     */
    _openWindow: function(url) {
        this.set("isRedirecting", true);
        this.set("redirectUrl", url);
    },

    /**
     * Called when submit triggers a form to close.
     *
     * The message returned in a successKey is displayed regardless in external forms, so we only care
     * if we are given a custom message to tack between our static messages. In any case, this needs to
     * flip the module into feedback mode, and no longer display the submitted form.
     *
     * @private
     */
    _onSubmitClose: function() {
        this.set("showForm", false);

        // If there was a custom URL defined, redirect to that on close, otherwise show error/success instead of the form
        if (this.get("isRedirecting") && !this._haveFeedback) {
            window.location.href = this.get("redirectUrl");
        } else {
            this.set("showSuccess", !!this.get("successMessage"));
            this.set("showError", !!this.get("errorMessage"));
            window.document.title = locale.get("form.done");
        }
    },

    /**
     * Display success message to user. Could come from default submission, or from custom
     * Display Feedback submit action. If no customMessage, blank out custom message text.
     * The custom message is flanked by default text in the View.
     *
     * @param msgObj with an optional customMessage property
     * @private
     */
    _displaySuccessFeedback: function(msgObj) {
        var msg = msgObj.customMessage ? msgObj.customMessage : " ";
        if (this.get("successMessage").length > 0) {
            this.set("successMessage", this.get("successMessage") + " ");
        }
        this.set("successMessage", this.get("successMessage") + msg);
        this._haveFeedback = true;
    },

    _displayDefaultSuccess: function() {
        this.set("successMessage", " ");
    },

    clearLastSubmit: function() {
        this._haveFeedback = false;
    },

    displayErrorFeedback: function(msg) {
        this.set("showError", true);
        this.set("errorMessage", msg);
        this._haveFeedback = true;
    }

});
